module.exports = __webpack_public_path__ + "static/media/03_tn.22c4f220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/03_tn.jpg
// module id = 217
// module chunks = 0